module.exports = __webpack_public_path__ + "static/media/8th_A.986298a5.png";